import { onClickOutside, onDelegatedEvent, randomString } from '../functions.js';

export default class BrandSelectorElement extends HTMLElement {

    #select = null;
    #popup = null;
    #popperInstance = null;

    connectedCallback() {
        this.#select = this.querySelector('select');
        this.#select.style.pointerEvents = 'none';
        this.#addHtml();
        this.#bindEvents();
        this.#refreshSelect();
    }

    #addHtml() {

        let options = [...this.#select.querySelectorAll('option')];

        options.sort((a, b) => {
            return a.disabled - b.disabled || a.textContent.localeCompare(b.textContent);
        });

        let html = `
            <div class="bselector__popup" style="display:none;">
            ${options.map(option => {
                if (option.value === '') {
                    return '';
                }

                let extraClass = option.disabled ? 'disabled' : '';
                let checked = (!option.disabled && (option.selected || option.dataset.selected)) ? 'checked' : '';

                let logo = '';
                if (option.dataset.logo) {
                    logo = `<img class="bselector__image" src="${option.dataset.logo}">`;
                }

                return `
                    <label class="bselector__item ${extraClass}">
                        <span class="form__checkbox form__checkbox--inline bselector__checkbox">
                            <input type="checkbox" value="${option.value}" data-label="${option.textContent}" ${checked}>
                        </span>
                        
                        <span class="bselector__brandname">${option.textContent}</span>
                        ${logo}
                    </label>
                `;
            }).join('\n')}
            </div>
        `;

        this.insertAdjacentHTML('beforeend', html);

        this.#popup = this.querySelector('.bselector__popup');

        this.#popperInstance = Popper.createPopper(
            this.#select,
            this.#popup, {
                modifiers: [
                    {
                      name: 'offset',
                      options: {
                        offset: [0, 10],
                      },
                    },
                ],
            }
        );
    }

    #bindEvents() {
        this.addEventListener('click', event => {

            let display = getComputedStyle(this.#popup).display;

            if (display === 'none') {
                this.#popup.style.display = '';
            } else {
                this.#popup.style.display = 'none';
            }

            this.#popperInstance.update();

        });

        onClickOutside(this, event => {
            this.#popup.style.display = 'none';
        });
        // this.#select.addEventListener('click', event => {
        //     console.log('clicked');
        //     event.preventDefault();
        //     event.stopPropagation();
        //     this.#select.blur();
        //     window.focus();
        //     return false;
        // });

        let changeEventTimeout = null;
        let closeTimeout = null;

        this.#popup.addEventListener('mousemove', event => {
            if (event.movementX + event.movementY > 5) {
                clearTimeout(closeTimeout);
            }
        });
        
        onDelegatedEvent('change', this, 'input[type=checkbox]', event => {
            this.#refreshSelect();

            clearTimeout(closeTimeout);
            clearTimeout(changeEventTimeout);

            changeEventTimeout = setTimeout(() => {
                this.dispatchEvent(new CustomEvent('brand-change', {
                    detail: {
                        brands: [...this.querySelectorAll('.bselector__item input[type=checkbox]:checked')].map(item => item.value)
                    },
                    bubbles: true
                }));
            }, 1000);

            closeTimeout = setTimeout(() => {
                this.#popup.style.display = 'none';
            }, 2000);

            if (event.selectorTarget.checked) {
                window.gtag && window.gtag('event', 'select_item', { item_brand: event.selectorTarget.value });
            }
        });
    }

    #refreshSelect() {
        let selected = [...this.querySelectorAll('.bselector__item input[type=checkbox]:checked')];
        let availableToSelect = [...this.#popup.querySelectorAll('.bselector__item:not(.disabled) input[type=checkbox]')];

        if (selected.length === 0 || availableToSelect.length === selected.length) {
            this.#select.querySelector('option[value=""]').textContent = 'Todas las marcas';
            return;
        }
        
        selected.sort((a, b) => {
            return a.dataset.label.localeCompare(b.dataset.label);
        });

        let labels = selected.map(item => item.dataset.label);

        let limit = 3;
        
        let firstPart = labels.slice(0, limit);
        let others = labels.slice(limit);

        let label = firstPart.join(', ') + (others.length ? ` y ${others.length} más` : '');

        this.#select.querySelector('option[value=""]').textContent = label;

    }

}

customElements.define('brand-selector', BrandSelectorElement);
